
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch business list
export const fetchBusinessList = createAsyncThunk(
  'business/fetchBusinessList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('https://onboard.rechargkit.biz/member/businessList');
      return response.data.businessList;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
  );

  const businessSlice = createSlice({
  name: 'business',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinessList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchBusinessList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default businessSlice.reducer;
